<template>
  <el-scrollbar ref="menuLeft" >
    <el-menu :collapse="collapse" class="h-full border-r-0" @select="onSelect" router :default-active="route.path">
      <SubMenu v-for="item in list" :item="item">

      </SubMenu>
    </el-menu>
  </el-scrollbar>
</template>

<script lang="ts" setup>
import { ElMenu, } from 'element-plus';
import SubMenu from './sub-menu.vue'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, reactive, ref } from 'vue'
const route = useRoute()
const menuLeft = ref<any>(null)
defineProps<{
  list: any[]
}>()
const router = useRouter()

const initialX = ref(0)
const collapse = ref(false)
const onSelect = (e: string) => {

  router.push(e)
}

 
</script>